// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".min-width {\n  min-width: 400px;\n}\n\n@media screen and (max-width: 360px) {\n  h2 {\n    font-size: 12px;\n  }\n  p, ion-button {\n    font-size: 10px;\n  }\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
